module.exports = __webpack_public_path__ + "img/Rent & Purchase Equipment .01dfc12e.jpeg";